import { useContext } from 'react'

import { Avatar, Box, Menu, Tooltip } from '@mantine/core'

import { RecruitersContext } from 'src/context/RecruitersContext'
import IconCheckmark from 'src/icons/IconCheckmark'

import { MenuChevron, TASK_MENU_CLASSNAMES } from './taskMenuStyles'

const getInitials = (label: string) => {
  const parts = label
    .replace(/\s*\(.*?\)\s*$/, '')
    .trim()
    .split(/\s+/)
  const first = parts[0]?.charAt(0) ?? ''
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : ''
  return (first + last).toUpperCase()
}

const AssigneeMenu = ({ assignees, setAssignees }) => {
  const recruiters = useContext(RecruitersContext) ?? []

  const toggleAssignee = (id: string) => {
    setAssignees((prev) =>
      prev.includes(id) ? prev.filter((a) => a !== id) : [...prev, id]
    )
  }

  const selected = (assignees ?? [])
    .map((id) => recruiters.find((r) => r.value === id))
    .filter(Boolean)

  return (
    <Menu
      offset={6}
      width={185}
      position="bottom-end"
      closeOnItemClick={false}
      classNames={TASK_MENU_CLASSNAMES}
    >
      <Menu.Target>
        <div className="flex cursor-pointer items-center gap-1">
          {selected.length === 0 ? (
            <span className="text-xs text-doubleNickel-gray-700 hover:text-doubleNickel-gray-900">
              No Assignee
            </span>
          ) : (
            <Avatar.Group spacing="0">
              <Tooltip label={selected[0].label} className="text-xs">
                <Avatar color="blue" size="sm" radius="sm">
                  {getInitials(selected[0].label)}
                </Avatar>
              </Tooltip>
              {selected.length > 1 && (
                <Tooltip
                  label={selected
                    .slice(1)
                    .map((r) => r.label)
                    .join(', ')}
                  className="text-xs"
                >
                  <Avatar size="sm" radius="sm">
                    +{selected.length - 1}
                  </Avatar>
                </Tooltip>
              )}
            </Avatar.Group>
          )}
          <MenuChevron />
        </div>
      </Menu.Target>
      <Menu.Dropdown className="max-h-[300px] overflow-y-auto">
        {recruiters.map((recruiter) => (
          <Menu.Item
            key={recruiter.value}
            onClick={() => toggleAssignee(recruiter.value)}
          >
            <Box className="flex flex-row items-center justify-between">
              {recruiter.label}
              {assignees?.includes(recruiter.value) && (
                <IconCheckmark className="h-4 w-4 fill-none stroke-doubleNickel-gray-500" />
              )}
            </Box>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}

export default AssigneeMenu
